import { render } from "./ButtonMain.vue?vue&type=template&id=55440d77&scoped=true&ts=true"
import script from "./ButtonMain.vue?vue&type=script&lang=ts"
export * from "./ButtonMain.vue?vue&type=script&lang=ts"

import "./ButtonMain.vue?vue&type=style&index=0&id=55440d77&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55440d77"]])

export default __exports__